import { z } from 'zod';

import { commonErrors } from '@utils/error';

export const dataConstants = {
	check: 'check',
	none: 'none',
	unsure: 'unsure',
	government: 'government',
	insuranceCoverage: 'insuranceCoverage',
};

export const testContent = {
	pageHeader: `Insurance coverage`,
	pageInfo: `If you have insurance, your plan may cover your clinical services (appointments, medications, labs). Some plans also cover FOLX membership fees.`,
	checkInsuranceDetail: {
		title: `Check my insurance`,
		description: `I have my insurance info on hand to see if I'm eligible.`,
	},
	noInsuranceDetail: {
		title: `I'm not using insurance`,
		description: `I'll pay for my membership and appointments out-of-pocket.`,
	},
	unsureInsuranceDetail: {
		title: `I'm not sure`,
		description: `I'll provide my insurance info later.`,
	},
	governmentInsuranceDetail: {
		title: `Government (Medicaid, Medicare, etc.)`,
		description: `Sorry, government-run plans are not eligible at this time.`,
	},
};

export const schema = z.object({
	insuranceCoverage: z.enum([dataConstants.check, dataConstants.none, dataConstants.unsure], {
		required_error: commonErrors.selectionRequired,
	}),
});
